module.exports = __webpack_public_path__ + "img/athira.56857118.png";